import { PersonnelModel } from '../../model';
import { PersonnelEntityState } from '../../type';

export type PersonnelEntity = {
  // Primary ID
  id: string;
  state: PersonnelEntityState;
  data: PersonnelModel;
};
